import React, {useState} from 'react';
import BtnPrimary from "./boiteAOutils/BtnPrimary";
import "./styles/catalogue.scss";
import BtnPlus from "./boiteAOutils/BtnPlus";
import BtnSecondary from "./boiteAOutils/BtnSecondary";
import Label from "./components/Widgets/WidgetPlanningActions/Composants/Label";
import Check from "./components/Widgets/WidgetPlanningActions/Icone/Check";
import IconeStatut from "./components/Widgets/WidgetPlanningActions/Icone/IconeStatut";
import logo_seizo_s from "./images/svg/logo_seizo_s.svg";
import logo_seizo_nom from "./images/svg/logo_seizo_nom.svg";
import BtnAction from "./boiteAOutils/BtnAction";
import ModalPrimary from "./boiteAOutils/ModalPrimary";
import BtnSvg from "./boiteAOutils/BtnSvg";
import CorbeilleSvg from "./boiteAOutils/SVG/CorbeilleSvg";
import CrayonSvg from "./boiteAOutils/SVG/CrayonSvg";
import DupliquerSvg from "./boiteAOutils/SVG/DupliquerSvg";
import QuitterSvg from "./boiteAOutils/SVG/QuitterSvg";
import DragDropSvg from "./boiteAOutils/SVG/DragDropSvg";
import CroixSvg from "./boiteAOutils/SVG/CroixSvg";
import CarreFlecheSortante from "./boiteAOutils/SVG/CarreFlecheSortante";
import BtnOrange from "./boiteAOutils/BtnOrange";
import PhidgetSvg from "./boiteAOutils/SVG/PhidgetSvg";
import Checkbox from "./boiteAOutils/Checkbox";
import ParametreSvg from "./boiteAOutils/SVG/ParametreSvg";
import FlecheRevenirSvg from "./boiteAOutils/SVG/FlecheRevenirSvg";
import WidgetMessagesInterServicesSvg from "./boiteAOutils/SVG/TypeWidget/WidgetMessagesInterServicesSvg";
import WidgetConsignesSvg from "./boiteAOutils/SVG/TypeWidget/WidgetConsignesSvg";
import WidgetDateHeureSvg from "./boiteAOutils/SVG/TypeWidget/WidgetDateHeureSvg";
import WidgetIndicateurSvg from "./boiteAOutils/SVG/TypeWidget/WidgetIndicateurSvg";
import WidgetMeteoSvg from "./boiteAOutils/SVG/TypeWidget/WidgetMeteoSvg";
import WidgetPlanningActionsSvg from "./boiteAOutils/SVG/TypeWidget/WidgetPlanningActionsSvg";
import WidgetRssSvg from "./boiteAOutils/SVG/TypeWidget/WidgetRssSvg";
import WidgetURLSvg from "./boiteAOutils/SVG/TypeWidget/WidgetURLSvg";
import WidgetYoutubeSvg from "./boiteAOutils/SVG/TypeWidget/WidgetYoutubeSvg";
import TroisPointsSvg from "./boiteAOutils/SVG/TroisPointsSvg";
import AncrageSvg from "./boiteAOutils/SVG/AncrageSvg";
import AnnotationSvg from "./boiteAOutils/SVG/AnnotationSvg";
import AideSvg from "./boiteAOutils/SVG/AideSvg";
import ModalInfos from "./boiteAOutils/ModalInfos";
import BtnTiertary from "./boiteAOutils/BtnTiertary";

const Catalogue = () => {
    const [showModalPrimary, setShowModalPrimary] = useState(false);

    const svgs = ['corbeille', 'crayon', 'dupliquer', 'quitter', 'drag_drop', 'croix', 'carre_fleche_sortante', 'phidget', 'parametre', 'fleche_revenir', 'trois_points', 'ancrage', 'annotation', 'aide'];

    const svgsTypeWidget = [
        {typeWidget: "Consignes", svg: <WidgetConsignesSvg width={40} height={40}/>},
        {typeWidget: "Date / Heure", svg: <WidgetDateHeureSvg width={40} height={40}/>},
        {typeWidget: "Indicateur", svg: <WidgetIndicateurSvg width={40} height={40}/>},
        {typeWidget: "Messages internes", svg: <WidgetMessagesInterServicesSvg width={40} height={40}/>},
        {typeWidget: "Météo", svg: <WidgetMeteoSvg width={40} height={40}/>},
        {typeWidget: "Planning d'actions", svg: <WidgetPlanningActionsSvg width={40} height={40}/>},
        {typeWidget: "Flux Rss", svg: <WidgetRssSvg width={40} height={40}/>},
        {typeWidget: "Page web", svg: <WidgetURLSvg width={40} height={40}/>},
        {typeWidget: "Youtube", svg: <WidgetYoutubeSvg width={40} height={40}/>}
    ];


    // Un objet qui associe chaque nom de SVG à son composant
    const svgComponents = {
        corbeille: <CorbeilleSvg/>,
        crayon: <CrayonSvg/>,
        dupliquer: <DupliquerSvg/>,
        quitter: <QuitterSvg/>,
        drag_drop: <DragDropSvg/>,
        croix: <CroixSvg/>,
        carre_fleche_sortante: <CarreFlecheSortante/>,
        phidget: <PhidgetSvg/>,
        parametre: <ParametreSvg/>,
        fleche_revenir: <FlecheRevenirSvg/>,
        trois_points: <TroisPointsSvg/>,
        ancrage: <AncrageSvg/>,
        annotation: <AnnotationSvg couleur={"#002335"}/>,
        aide: <AideSvg/>
    };

    const handleClickBouton = () => {
        alert('Tu as cliqué sur le bouton');
    }

    // Liste des couleurs disponibles
    const couleurs = [
        {nom: 'SEIZO-dark', variable: '--SEIZO-dark'},
        {nom: 'SEIZO-claire', variable: '--SEIZO-claire', couleurTxt: 'black'},
        {nom: 'SEIZO-rouge', variable: '--SEIZO-rouge'},
        {nom: 'SEIZO-bleu', variable: '--SEIZO-bleu'},
        {nom: 'SEIZO-jaune', variable: '--SEIZO-jaune', couleurTxt: 'black'},
        {nom: 'SEIZO-vert', variable: '--SEIZO-vert'},
        {nom: 'SEIZO-orange', variable: '--SEIZO-orange'},
    ];

    // Fonction pour récupérer la valeur d'une variable CSS
    const getCssVariableValue = (variable) => {
        return getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
    };

    return (
        <div>
            <h1>Catalogue</h1>
            <div className="grid-container">
                <h2>SVG</h2>
                <div className="grid-item">
                    <div className={"nomItem"}>logo_seizo_s.svg</div>
                    <div className={"container-element"}>
                        <img src={logo_seizo_s} alt="Logo SEIZO"/>

                    </div>
                </div>
                <div className="grid-item">
                    <div className={"nomItem"}>logo_seizo_nom.svg</div>
                    <div className={"container-element"}>
                        <img src={logo_seizo_nom} alt="Logo SEIZO nom"/>
                    </div>
                </div>
                {svgs.map(name => (
                    <div className="grid-item" key={name}>
                        <div className={"nomItem"}>{`${name}.svg`}</div>
                        <div className={"container-element"}>
                            {svgComponents[name]} {/* Affiche le composant SVG correspondant */}
                        </div>
                    </div>
                ))}
            </div>

            <div className="grid-container">
                <h2>SVG par type de Widget</h2>
                {svgsTypeWidget.map((svgTypeWidget) => (
                    <div className="grid-item" key={svgTypeWidget.typeWidget}>
                        <div className={"nomItem"}>{svgTypeWidget.typeWidget}</div>
                        <div className={"container-element"}>
                            {svgTypeWidget.svg} {/* Affiche le composant SVG correspondant */}
                        </div>
                    </div>
                ))}
            </div>

            <div className="grid-container">
                <h2>Couleurs Disponibles</h2>
                {couleurs.map(couleur => (
                    <div key={couleur.nom} className="grid-item"
                         style={{
                             backgroundColor: getCssVariableValue(couleur.variable),
                             color: couleur.couleurTxt ?? "white"
                         }}>
                        <div className={"nomItem"}>{couleur.nom}</div>
                        <div className={"container-element"}>{getCssVariableValue(couleur.variable)}</div>
                    </div>
                ))}
            </div>


            <div className="grid-container">
                <h2>Boutons</h2>
                <div className="grid-item">
                    <div className={"nomItem"}>BtnAction</div>
                    <div className={"container-element"}>
                        <BtnAction onClick={handleClickBouton}>BtnAction</BtnAction>
                        <BtnAction onClick={handleClickBouton} badge={1}>BtnAction</BtnAction>
                        <BtnAction onClick={handleClickBouton} bord={false}>BtnAction</BtnAction>
                    </div>
                    <div className={"helpItem"}>Avec ou sans badge, avec ou sans bord</div>
                </div>
                <div className="grid-item">
                    <div className={"nomItem"}>BtnPrimary</div>
                    <div className={"container-element"}>
                        <BtnPrimary onClick={handleClickBouton}>BtnPrimary</BtnPrimary>
                        <BtnPrimary onClick={handleClickBouton} disabled={true}>BtnPrimary</BtnPrimary>
                    </div>
                    <div className={"helpItem"}>Disabled ou non</div>
                </div>
                <div className="grid-item">
                    <div className={"nomItem"}>BtnSecondary</div>
                    <div className={"container-element"}>
                        <BtnSecondary onClick={handleClickBouton}>BtnSecondary</BtnSecondary>
                    </div>
                </div>
                <div className="grid-item">
                    <div className={"nomItem"}>BtnTiertary</div>
                    <div className={"container-element"}>
                        <BtnTiertary onClick={handleClickBouton}>BtnTiertary</BtnTiertary>
                        <BtnTiertary onClick={handleClickBouton} disabled={true}>BtnTiertary</BtnTiertary>
                    </div>
                </div>
                <div className="grid-item">
                    <div className={"nomItem"}>BtnOrange</div>
                    <div className={"container-element"}>
                        <BtnOrange onClick={handleClickBouton}>BtnOrange</BtnOrange>
                    </div>
                </div>
                <div className="grid-item">
                    <div className={"nomItem"}>BtnPlus</div>
                    <BtnPlus onClick={handleClickBouton}/>
                </div>
                <div className="grid-item">
                    <div className={"nomItem"}>Checkbox</div>
                    <div className={"container-element"}>
                        <Checkbox onClick={handleClickBouton} label={"Checkbox true"} checked={true}
                                  id_input={"input_true"}/>
                        <Checkbox onClick={handleClickBouton} label={"Checkbox false"} checked={false}
                                  id_input={"input_false"}/>
                    </div>
                </div>
            </div>

            <div className="grid-container">
                <div>
                    <h2>BtnSvg</h2>
                    <p>Tailles :<br/>petit (20 sur 20) / grand (40 sur 40) / personnalisable (width / height)</p>
                </div>
                <table>
                    <tbody>
                    {svgs.map((svg) => (
                        <tr key={svg}>
                            <th>{svg}</th>
                            <td><BtnSvg svg={svg} onClick={handleClickBouton}/></td>
                            <td><BtnSvg svg={svg} onClick={handleClickBouton} taille={"grand"}/></td>
                            <td><BtnSvg svg={svg} onClick={handleClickBouton} width={60} height={60}/></td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>

            <div className="grid-container">
                <h2>Modal</h2>
                <div className="grid-item">
                    <div className={"nomItem"}>Modal d'action</div>
                    <div className={"container-element"}>
                        <BtnPrimary onClick={() => setShowModalPrimary(true)}>Ouvrir la modal</BtnPrimary>
                        {
                            /*** Modal Primary ***/
                            showModalPrimary ? (
                                <ModalPrimary
                                    textTitle={"Texte principal de la modal"}
                                    textComment={"Texte de détails"}
                                    textBtnValidate={"Texte du bouton valider"}
                                    textBtnCancel={"Texte bouton retour / annuler"}
                                    onCancel={() => setShowModalPrimary(false)}
                                />
                            ) : null
                        }
                    </div>
                    <div className={"helpItem"}><span style={{fontStyle: "italic"}}>showValidateBtn</span>(true/false)
                        permet de masquer le bouton de validation
                    </div>
                </div>
                <div className="grid-item">
                    <div className={"nomItem"}>Modal d'informations</div>
                    <div className={"container-element"}>
                        <ModalInfos
                            titre="Titre de la modal"
                            children="Voici le contenu de la modal"
                        />
                    </div>
                </div>
            </div>

            <div className="grid-container">
                <h2>Planning d'actions</h2>
                <div className="grid-item">
                    <div className={"nomItem"}>Label</div>
                    <div className={"container-element"}>
                        <Label contenu={"label"}/>
                        <Label contenu={"label"} isRequired={true}/>
                    </div>
                    <div className={"helpItem"}>Requis ou non requis</div>
                </div>
                <div className="grid-item">
                    <div className={"nomItem"}>Icône check</div>
                    <div className={"container-element"}>
                        <Check/>
                        <Check couleur={"#ff7979"}/>
                        <Check couleur={"#f9ca24"}/>
                        <Check couleur={"#e056fd"}/>
                        <div>...</div>
                    </div>
                    <div className={"helpItem"}>couleur personnalisable</div>
                </div>
                <div className="grid-item">
                    <div className={"nomItem"}>Icône reporté</div>
                    <div className={"container-element"}>
                        <IconeStatut icone={"Reporte"}/>
                        <IconeStatut icone={"Reporte"} couleur={"#8e44ad"}/>
                        <IconeStatut icone={"Reporte"} couleur={"#f1c40f"}/>
                        <IconeStatut icone={"Reporte"} couleur={"#2ecc71"}/>
                        <div>...</div>
                    </div>
                    <div className={"helpItem"}>couleur personnalisable</div>
                </div>
                <div className="grid-item">
                    <div className={"nomItem"}>Icône rond</div>
                    <div className={"container-element"}>
                        <IconeStatut icone={"Rond"}/>
                        <IconeStatut icone={"Rond"} couleur={"#1abc9c"}/>
                        <IconeStatut icone={"Rond"} couleur={"#2980b9"}/>
                        <IconeStatut icone={"Rond"} couleur={"#e67e22"}/>
                        <div>...</div>
                    </div>
                    <div className={"helpItem"}>couleur personnalisable</div>
                </div>
            </div>
        </div>
    );
};

export default Catalogue;